import { serviceAPI } from "../../axios";
export const actions = {
    getSingleDeliveryUnitServiceMap(context, data){
        return serviceAPI.get(`DeliveryUnitServiceMap/${data}`);
    },
    createDeliveryUnitServiceMap(context, data){
        return serviceAPI.post(`DeliveryUnitServiceMap`, data);
    },
    updateDeliveryUnitServiceMap(context, data){
        return serviceAPI.put(`DeliveryUnitServiceMap/${data.id}`, data);
    },
    deleteDeliveryUnitServiceMap(context, data){
        return serviceAPI.delete(`DeliveryUnitServiceMap/${data}`);
    },
    getDeliveryUnitByService(context, data){
        return serviceAPI.get(`DeliveryUnitServiceMap/ByDeliveryUnitService/${data}`);
    },
    getDeliveryUnitChildren(context, data){
        return serviceAPI.get(`DeliveryUnitServiceMap/Child/${data}`);
    }
}